const pages = {}

export default pages
